export const monospace = "'Roboto Mono', Menlo, Monaco, Consolas, 'Courier New', monospace";
